import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { Avatar, useTheme } from '@mui/material';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';

export interface UserAvatarProps {
  size?: number; // in px
}

const useStyles = makeStyles<UserAvatarProps>()((theme, props) => {
  return {
    avatar: {
      width: props.size ?? 45,
      height: props.size ?? 45,
      background: '#fff',
      color: theme.palette.primary.main,
    },
  };
});

const UserAvatar: React.FC<UserAvatarProps> = ({ size }) => {
  const { classes } = useStyles({ size });
  const theme = useTheme();

  return (
    <Avatar
      className={classes.avatar}
      sx={{ bgcolor: theme.palette.primary.main }}
      aria-label="Account Settings"
    >
      <ManageAccountsIcon sx={{ fontSize: '2rem' }} />
    </Avatar>
  );
};

export default UserAvatar;
